module.exports = __webpack_public_path__ + "img/b2.2d62159c.png";